// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1l_VY","newExpiryDate":"styles_newExpiryDate__2d0qv","footer":"styles_footer__3vDlO"};